import type { Layer } from '../store/slices/layersSlice';

export const DEMO_PARCEL_LAYER: Layer = {
  id: 'demo-sample-parcel-101',
  name: 'Sample Parcel #101 (Greenfield Site)',
  type: 'vector',
  geometryType: 'Polygon',
  visible: true,
  opacity: 1,
  zIndex: 1,
  featureCount: 1,
  symbology: {
    fillColor: 'rgba(132, 204, 22, 0.25)',
    strokeColor: '#84cc16',
    strokeWidth: 2,
  },
  crs: 'EPSG:4326',
  features: [
    {
      id: 'demo-feature-101',
      layerId: 'demo-sample-parcel-101',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [77.592, 12.971],
            [77.596, 12.971],
            [77.595, 12.975],
            [77.591, 12.974],
            [77.592, 12.971],
          ],
        ],
      },
      properties: {
        Parcel_ID: 'GRN-2026-08',
        Land_Use: 'Commercial Development',
        Area_Acres: 2.45,
        Owner: 'Greenfield Realty Ltd.',
        DIGIPIN: '382-942-810',
        Status: 'Active Survey',
      },
    },
  ],
};
